import { Box, Alert, AlertIcon, AlertDescription, CloseButton, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const STORAGE_KEY = 'maintenance_notification_dismissed';

export function MaintenanceNotification() {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure({ defaultIsOpen: false });

  useEffect(() => {
    // Listen for maintenance event
    const handleMaintenance = () => {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (!dismissed) {
        onOpen();
      }
    };

    // Listen for server recovered event
    const handleRecovered = () => {
      localStorage.removeItem(STORAGE_KEY);
      onClose();
    };

    window.addEventListener('server-maintenance', handleMaintenance);
    window.addEventListener('server-recovered', handleRecovered);

    return () => {
      window.removeEventListener('server-maintenance', handleMaintenance);
      window.removeEventListener('server-recovered', handleRecovered);
    };
  }, [onOpen, onClose]);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Box
      position="fixed"
      bottom={4}
      right={4}
      maxW="400px"
      zIndex={9999}
      boxShadow="lg"
    >
      <Alert status="warning" borderRadius="md">
        <AlertIcon />
        <AlertDescription flex="1" fontSize="sm">
          {t('maintenance.message')}
        </AlertDescription>
        <CloseButton
          position="absolute"
          right={2}
          top={2}
          onClick={handleClose}
        />
      </Alert>
    </Box>
  );
}

